import { Component, OnInit } from '@angular/core';
import { StringChain } from 'lodash';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
export interface Area {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idCliente: number;
}
export interface AreaComponente {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idArea: number;
  idComponente: number;
  idCliente: number;
}
export interface Origen {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idCliente: number;
}
export interface Componente {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idCliente: number;
  tieneZona: boolean;
  tieneCuadrante: boolean;
  idZonaCuadrante: number;
}
export interface GrupoTipo {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  clienteId: number;
}
export interface Clasificacion {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idCliente: number;
}
export interface Tipo {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idGrupoAveria: number;
  idCliente: number;
}
export interface Severidad {
  descripcion: string;
  descripcionAbreviada: string;
  codigoExterno: string;
  idCliente: number;
}
export interface FotosAveriasDTO {
  id: number;
  foto: string;
}
export interface consultaDiscrepanciasDTO {
  idCliente: number;
  proceso: string;
  fechaDesde: string;
  fechaHasta: string;
  activo: Boolean;
}
export interface DiscrepanciaDTO {
  id: number;
  cedente: string;
  receptor: string;
  activo: boolean;
  estado: string;
  solucionada: boolean;
  vinAveria: VinAveriaDetalleDTO;
  inspeccionVinAveria: InspeccionVinAveriasDetalleDTO;
  comentario: string;
  comentarioModificacion: string;
}
export interface VinAveriaDetalleDTO {
  id: number;
  vin: string;
  idAreaComponente: number;
  areaComponente: string;
  idZonaCuadranteDetalle: number;
  zonaCuadranteDetalle: string;
  idTipoAveria: number;
  tipoAveria: string;
  idSeveridad: number;
  severidad: string;
  idResponsable: number;
  responsable: string;
  fecha: string;
  observacion: string;
  idEstadoAveria: number;
  estadoAveria: string;
  usuarioAlta: string;
  fechaAlta: string;
  usuarioUltimaMod: string;
  fechaUltimaMod: string;
  origen: string;
  clasificacion: string;

  fotosAveria: FotosAveriasDTO[];
}
export interface InspeccionVinAveriasDetalleDTO {
  id: number;
  vin: string;
  idAreaComponente: number;
  areaComponente: string;
  idZonaCuadranteDetalle: number;
  zonaCuadranteDetalle: string;
  idTipoAveria: number;
  tipoAveria: string;
  idSeveridad: number;
  severidad: string;
  idResponsable: number;
  responsable: string;
  fecha: string;
  observacion: string;
  idEstadoAveria: number;
  estadoAveria: string;
  usuarioAlta: string;
  fechaAlta: string;
  usuarioUltimaMod: string;
  fechaUltimaMod: string;
  listaFotosAveria: FotosAveriasDTO[];
  origen: string;
  clasificacion: string;
}
export interface detallesDiscrepancia {
  idDiscrepancia: number;
  idVinAveria: number;
  vin: string;
  receptor: string;
  idZonaCuadranteDetalle: number;
  zonaCuadranteDetalle: string;
  idAreaComponente: number;
  areaComponente: string;
  idTipoAveria: number;
  tipoAveria: string;
  idSeveridad: number;
  severidad: string;
  condicionInspeccion: string;
  condicionUnidad: string;
  modelo: string;
  cedente: string;
  idResponsable: number;
  responsable: string;
  clasificacion: string;
  idClasificacion: number;
  comentarioDiscrepancia: string;
  listaFotosAverias: FotosAveriasDTO[];
  solucionada: boolean;
  comentarioModificacion: string;
}
export interface detallesDiscrepanciaSolucionadas {
  vin: string;
  receptor: string;
  areaReceptor: string;
  averiaReceptor: string;
  severidadCedente: string;
  cedente: string;
  areaCedente: string;
  averiaCedente;
  severidadReceptor: string;
  correctaReceptor: boolean;
  correctaCedente: boolean;
  // incorrectaReceptor: boolean,
  // incorrectaCedente: boolean,
  listaFotosAverias: FotosAveriasDTO[];
  listaFotosInspecciones: FotosAveriasDTO[];
  comentarioModificacion: string;
}
export interface seguros {
  id: number;
  modelo: string;
  vin: string;
  clasificacion: string;
  areaComponente: string;
  tipoAveria: string;
  severidad: string;
  codAreaComponente: string;
  codTipoAveria: string;
  codSeveridad: string;
  seguro: boolean;
}
export interface debitos {
  id: number;
  modelo: string;
  vin: string;
  clasificacion: string;
  areaComponente: string;
  tipoAveria: string;
  severidad: string;
  codAreaComponente: string;
  codTipoAveria: string;
  codSeveridad: string;
  debito: boolean;
  pago: boolean;
}
export interface debitosDTO {
  // id:number,
  idVinAverias: string;
  okDebito: boolean;
  okPago: boolean;
  okSeguro: boolean;
}

export interface debitosConsulta {
  idCliente: number;
  fechaDesde: Date;
  fechaHasta: Date;
  operador: number;
}

export interface segurosDTO {
  idVinAverias: string;
  okDebito: boolean;
  okPago: boolean;
  okSeguro: boolean;
}

export interface CriterioSimilitudDTO {
  idCliente: number;
  descripcion: string;
  descripcionAbreviada: string;
  orden: number;
  criterioSeveridad: number[];
  criterioZonaCuadrante: number[];
  criterioTipoAveria: number[];
}

export interface CriterioSimilitudModificarDTO {
  idCriterioSimilitud: number;
  descripcion: string;
  descripcionAbreviada: string;
  criterioSeveridad: number[];
  criterioZonaCuadrante: number[];
  criterioTipoAveria: number[];
  orden: number;
}

export interface CriterioSimilitudConsultar {
  idCriterioSimilitud: number;
  criterioSimilitud: string;
  descripcionAbreviada: string;
  listaCriterioTipoAveria: number[];
  listaCriterioSeveridad: number[];
  listaCriterioZonaCuadrante: number[];
  orden: number;
}

export interface solucionarDiscrepanciaDTO {
  idDiscrepancia: number;
  idVinAveria: number;
  idTipoAveria: number;
  idSeveridad: number;
  idResponsable: number;
  idClasificacion: number;
}

export interface usersDTO {
  id: number;
  username: string;
  nombre: string;
  apellido: string;
  correoElectronico: string;
  perfil: {
    id: number;
    descripcion: string;
    operador: boolean;
    cliente: boolean;
    perfilRoles: [
      {
        id: number;
        rol: {
          id: number;
          descripcion: string;
        };
      }
    ];
  };
  operador: {
    id: number;
    descripcion: string;
  };
  clientes: [
    {
      id: number;
      descripcion: string;
    }
  ];
}
export interface reportesDTO {
  idVinAverias: number[];
  idTipoReporte: number;
  transporte: string;
  fechaDesde: Date;
  fechaHasta: Date;
  responsable: number;
  procesos: string;
  vin: string;

  grilla: boolean;
  porModelo: boolean;
  porClasif: boolean;
  indicadores: boolean;
  detalles: boolean;
  fotos: boolean;
  cantInsp: number;
  cantAverias: number;
  idReceptor: number;
  codigoVisitaExterna: string;
  idCliente : number;
  idbuque: number; 
  filtrogrid:  { [key: string]: any };// opcional para algunos reportes
}
export interface operadores {
  idTipoOperador: number;
  descripcion: string;
  descripcionAbreviada: string;
}

export interface passwordDTO {
  username: string;
  password: string;
}

export interface Valorizacion {
  operador: number;
  tipoAveria: number;
  severidad: number;
  valor: string;
}

export interface modeloDTO {
  descripcion: string;
  descripcionAbreviada: string;
  idCliente: number;
}
export interface buquesDTO {
  descripcion: string;
  idOperador: number;
}

export interface modeloDTO {
  descripcion: string;
  descripcionAbreviada: string;
  idCliente: number;
}

export interface vinDTO {
  vin: string;
  idModelo: number;
}

export interface codificacionModelosDTO {
  // codificacion: string,
  codificacion: string[];
  idModelo: string;
  // idModelo: number,
  eliminado: boolean;
  idCliente: number;
}

export interface visitaBuqueDTO {
  idVisita: number;
  idBuque: number;
  proceso: string;
  nombreBuque: string;
  codVisitaExterno: string;
  fechaArribo: Date;
  fechaPartida: Date;
  etd: Date;
  eta: Date;
  ata: Date;
  atd: Date;
  idProceso: number;
  codVerificacion: number;
}

export interface consultaAveriasDTO {
  receptor: number[];
  cedente: number[];
  fechaDesdeInspeccion: string;
  fechaHastaInspeccion: string;
  responsable: number[];
  proceso: string;
  vin: string;
  transporte: string;
  transporteReceptor: string;
  idCliente: number;
  idTipoReporte: number;
  codigoVisitaExterna : string;
  idbuque: number;
}

export interface visitaExistenteDTO {
  idCliente: number;
  idTipoProceso: number;
  idBuque: number;
  codVisitaExt: String;
  idOperador: number;
}

export interface vinsVisitaDTO {
  idBuque: number;
  idCliente: number;
  codVisitaExterno: string;
  idOperador: number;
  idTipoProceso: number;
  ETD: Date;
  ETA: Date;
  ATA: Date;
  ATD: Date;
  vins: vinsVisita[];
}

export interface vinsVisita {
  vin: string;
  destinoOrigen: string;
  numeroFactura: string;
  bl: string;
}

export interface altaUsuario {
  REcontrasenia: string;
  apellido: string;
  contrasenia: string;
  dni: number;
  email: string;
  nombre: string;
  nombreDeUsuario: string;
}

export interface EliminarManualData {
  nombre: string;
  idManual: number;
}

@Component({
    selector: 'app-entidades',
    templateUrl: './entidades.component.html',
    styleUrls: ['./entidades.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, MultiSelectModule],
})
export class EntidadesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
